$(document).ready(function () {
    let data = new FormData()

    $("#list-sliders-home").sortable({
        update: function (event, ui) {
            update(event, ui); // Llamada a la función update al mover un elemento
        }
    })

    window.update = function (event, ui) {
        let order = [];
        $("#list-sliders-home li").each(function (index) {
            order.push({
                id: $(this).data('id'),
                order: index + 1
            });
        });

        let data = new FormData();
        data.append('items', JSON.stringify(order));
        updatePosition(data, "Registro actualizado");
    }

    function updatePosition(data, msg) {
        $(".loader_").addClass("loading")
        $.ajax({
            method: "POST",
            url: "/admin/update-position-slider",
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: data,
            success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    alertSuccess(msg)
                    document.getElementById('div_partials_sliders').innerHTML = response;
                    $("#list-sliders-home").sortable({
                        update: function (event, ui) {
                            update(event, ui); // Llamada a la función update al mover un elemento
                        }
                    });
                }, 1000)
            }
        })
    }
})

